module.exports = __webpack_public_path__ + "images/pj02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pj02.jpg
// module id = 122
// module chunks = 0